import { SearchFacetsBaseJSON } from '../../../../../../../../rest/viya-catalog/catalog/search/representations';
import { RequestParamLimit, RequestParamStart } from '../../../../../../../../rest/viya-sonder/rest/paging';
import { CollectionMediaTypeJSON } from '../../../../../../../../rest/viya-sonder/rest/representations/commons/commons';
import { fetchBody } from '../../../../../../../../util/service';
export const GO_MAX_INT16 = 32767;

// GetSearchSuggestions - gets type ahead search suggestions for items available in catalog
export const GetSearchSuggestions = async req => {
  const params = {
    facet: req.facet,
    [RequestParamStart]: 0,
    [RequestParamLimit]: req.limit
  };
  if (req.value !== '') {
    params.q = req.value;
  }
  if (req.indices.length > 0) {
    params.indices = req.indices.join(',');
  }
  const response = await fetchBody({
    method: 'GET',
    url: '/catalog/search/suggestions',
    params,
    headers: {
      Accept: CollectionMediaTypeJSON,
      'Accept-Item': 'text/plain'
    }
  });
  const collection = response;
  return collection;
};

// GetSearchFacets - gets all facets (for all indices) available for searching on within catalog
export const GetSearchFacets = async () => {
  const response = await fetchBody({
    method: 'GET',
    url: '/catalog/search/facets',
    params: {
      [RequestParamStart]: 0,
      [RequestParamLimit]: 1000,
      includeHidden: 'true'
    },
    headers: {
      Accept: CollectionMediaTypeJSON,
      'Accept-Item': SearchFacetsBaseJSON
    }
  });
  const collection = response;
  return collection;
};
//# sourceMappingURL=catalogServiceAccessorREST.js.map